export const shouldShowLive = (catalogStatus: string, isCatalogOnly: boolean, saleStartTs: number) => {
    const now = new Date();
    const secondsUntilStart = saleStartTs - now.getTime() / 1000;
    return (
        !isCatalogOnly &&
        (catalogStatus === 'live' ||
            catalogStatus === 'paused' ||
            (catalogStatus === 'online' && secondsUntilStart < 60 * 10))
    );
};
